export const getVerticalFooterData = () => [];

